module.exports = __webpack_public_path__ + "img/mbanner_tv.459bf0c2.jpg";